export default function Exhibition() {
  const exhibitionFeatures = [
    {
      icon: 'ri-community-line',
      title: 'أجنحة الجمعيات الشبابية',
      description: 'عرض مبادرات وبرامج الجمعيات الشبابية المختلفة من جميع أنحاء المملكة',
      color: 'from-[#1B5E20] to-[#2E7D32]'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'مبادرات شبابية مبتكرة',
      description: 'عرض المشاريع والأفكار الشبابية الإبداعية والحلول المبتكرة',
      color: 'from-[#D4AF37] to-[#B8941F]'
    },
    {
      icon: 'ri-building-line',
      title: 'منصات رعاة الملتقى',
      description: 'التعريف بالجهات الداعمة والشريكة وعرض خدماتها ومبادراتها',
      color: 'from-[#2E7D32] to-[#1B5E20]'
    }
  ];

  return (
    <section id="exhibition" className="py-12 md:py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#1B5E20] text-sm font-bold tracking-wider uppercase">المعرض المصاحب</span>
            <div className="h-1 w-16 bg-[#1B5E20] mt-2 mx-auto"></div>
          </div>
          <h2 className="text-5xl font-bold text-[#1B5E20] mb-6">معرض الابتكار الشبابي</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            معرض متكامل يستمر طيلة أيام الملتقى لعرض مبادرات الجمعيات والمشاريع الشبابية المبتكرة
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {exhibitionFeatures.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 overflow-hidden"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${feature.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
              <div className="relative z-10">
                <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${feature.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feature.icon} text-4xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#F5F5DC] to-[#FFF8DC] rounded-3xl p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-[#1B5E20] mb-6">تفاصيل المعرض</h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0 shadow-md">
                    <i className="ri-time-line text-2xl text-[#1B5E20]"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-800 mb-1">المدة</h4>
                    <p className="text-gray-600">طيلة أيام الملتقى (يومان كاملان)</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0 shadow-md">
                    <i className="ri-store-line text-2xl text-[#1B5E20]"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-800 mb-1">عدد الأجنحة</h4>
                    <p className="text-gray-600">+10 أجنحة للجمعيات والمبادرات</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0 shadow-md">
                    <i className="ri-team-line text-2xl text-[#1B5E20]"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-800 mb-1">الزوار المتوقعون</h4>
                    <p className="text-gray-600">+200 زائر من المهتمين والشباب</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0 shadow-md">
                    <i className="ri-gift-line text-2xl text-[#1B5E20]"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-800 mb-1">الفعاليات التفاعلية</h4>
                    <p className="text-gray-600">مسابقات وجوائز وتجارب تفاعلية</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20exhibition%20hall%20with%20multiple%20booths%20displays%20youth%20innovation%20showcase%20bright%20lighting%20professional%20setup%20saudi%20arabia%20cultural%20elements%20green%20gold%20accents%20contemporary%20design%20people%20networking%20interactive%20displays&width=800&height=600&seq=exhibition-001&orientation=landscape"
                  alt="المعرض المصاحب"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-6 shadow-xl border-4 border-[#D4AF37]">
                <div className="text-center">
                  <div className="text-4xl font-bold text-[#1B5E20]">10+</div>
                  <div className="text-sm text-gray-600 font-medium">أجنحة عرض</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-[#1B5E20] text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg">
            <i className="ri-information-line text-2xl"></i>
            <span>الدخول مجاني لجميع المشاركين في الملتقى</span>
          </div>
        </div>
      </div>
    </section>
  );
}
